export { AmplifyService } from './amplify.service';
export { AuthState } from './auth.state';
export { default as AmplifyModules } from './amplify.compose.service';
